<template>
    <div>
        <b-overlay :show="loading" opacity="0.6">

            <div class="header-img with-bg" :style="{ backgroundImage: 'url(' + categoryDetails.categoryImage + ')' }">
                <h1 class="page-title">{{subCategoryDetails.name}}.</h1>
            </div>

            <b-container class="menu-container pt-4">

                <transition-group tag="ul" name="slide-in" class="menu-items-container" :style="{ '--total': menuItems.length }">
                    <li @click="openModifier(menuItem.id)" class="menu-item" v-for="(menuItem, index) in menuItems" :key="index"
                        :style="{'--i': index}"
                    >
                        <div class="item-meta">
                            <h5>{{ menuItem.name }}</h5>
                            <p>{{ menuItem.description }}</p>
                        </div>
                        <div class="item-action">
                            £{{ formatMoney(menuItem.price)}}
                        </div>
                    </li>
                </transition-group>


                <p class="text-center" v-show="menuItems.length == 0">No menu items available.</p>

            </b-container>
        </b-overlay>
        <modifier-sheet @close="isModifierOpen = false" :item_id="item_id" v-show="isModifierOpen"></modifier-sheet>

    </div>
</template>

<script>
    import { VueperSlides, VueperSlide } from "vueperslides";
    import "vueperslides/dist/vueperslides.css";

    import ModifierSheet from "./Modifiers/ModifierSheet";

    export default {
        name: "Menu",
        components: {ModifierSheet, VueperSlides, VueperSlide},
        data() {
            return {
                isModifierOpen: false,
                loading: false,
                category_id: this.$route.params.category_id,
                sub_cat_id: this.$route.params.sub_cat_id,
                categoryDetails: '',
                subCategoryDetails: '',
                menuItems: '',
                item_id: '',
            }
        },

        mounted() {
            this.getInitialDetails();
        },

        methods: {
            openModifier(item_id) {
                this.isModifierOpen = true;
                this.item_id = item_id;
            },

            getInitialDetails() {
                this.loading = true;
                console.log("Getting category details");
                axios.get('/item/category/' + this.category_id).then(response => {
                    console.log("loaded category details & sub categories.")
                    this.categoryDetails = response.data;
                    this.getSubCatDetails()
                    console.log('Loading items based on first menu item.')
                    this.getMenuItems(this.sub_cat_id)
                    this.loading = false;
                })
            },

            getSubCatDetails() {
                console.log("Loading data...");
                axios.get('/item/subcategory/' + this.sub_cat_id).then(response => {
                    this.subCategoryDetails = response.data;
                    console.log('subcatdetails', response.data)
                })
            },

            getMenuItems(sub_cat_id) {
                axios.get('/items/' + sub_cat_id).then(response => {
                    this.menuItems = response.data;
                    console.log('menuItems',this.menuItems)
                })
            },

            formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
                try {
                    decimalCount = Math.abs(decimalCount);
                    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                    const negativeSign = amount < 0 ? "-" : "";

                    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                    let j = (i.length > 3) ? i.length % 3 : 0;

                    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
                } catch (e) {
                    console.log(e)
                }
            },

        }

    }
</script>

<style scoped lang="scss">
    .slide-in {

        &-move {
            transition: opacity .5s linear, transform .5s ease-in-out;
        }

        &-leave-active {
            transition: opacity .4s linear, transform .4s cubic-bezier(.5,0,.7,.4); //cubic-bezier(.7,0,.7,1);
            transition-delay: calc( 0.1s * (var(--total) - var(--i)) );
        }

        &-enter-active {
            transition: opacity .5s linear, transform .5s cubic-bezier(.2,.5,.1,1);
            transition-delay: calc( 0.1s * var(--i) );
        }

        &-enter,
        &-leave-to {
            opacity: 0;
        }

        &-enter { transform: translateX(-1em); }
        &-leave-to { transform: translateX(1em); }

    }


</style>